module.exports = __webpack_public_path__ + "static/media/farbod_nowzad.8ef6d8ce.jpeg";